import AOS from 'aos';
import { SanityBlocks } from 'sanity-blocks-vue-component';

export default {
  components: { SanityBlocks },
  mounted() {
    AOS.init();
  },
};
